/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { Address, AddressProviderProps } from '~types/index'

import React, { FC, useState } from 'react'

import { setCookieCSR } from '@/app/api/CSR/setCookieCSR'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'

interface updateAddressProps {
  (address: Address): void
}

export const AddressContext = React.createContext<{
  address: Address
  updateAddress: updateAddressProps
  clearAddress: () => void
}>({ address: {}, updateAddress: console.log, clearAddress: console.log })

export const useAddressContext = () => React.useContext(AddressContext)

export const AddressProvider: FC<AddressProviderProps> = ({
  children,
  address: storeAddress,
}) => {
  const [address, setAddress] = useState<Address>(storeAddress || {})

  const updateAddress: updateAddressProps = (address) => {
    if (typeof window !== 'undefined') {
      window?.localStorage?.setItem('selectedAddress', JSON.stringify(address))
    }
    selectedMutations.updateAddress(address)
    setCookieCSR('_IL-selectedAddress', JSON.stringify(address), 1)
    setAddress(address)
  }

  const clearAddress = () => {
    setAddress({})
    if (typeof window !== 'undefined') {
      window?.localStorage?.removeItem('selectedAddress')
      setCookieCSR('_IL-selectedAddress', '', -1)
    }
    selectedMutations.updateAddress({})
  }

  return (
    <AddressContext.Provider value={{ address, updateAddress, clearAddress }}>
      {children}
    </AddressContext.Provider>
  )
}
